module.exports = __webpack_public_path__ + "media/images/users/user-7-2639ccca7817ff3df59b3bdd78297eb4.jpg";